<template>
  <div class="card form-card">
    <div v-if="showTitle"
         class="form-card-header px-i"
         :class="{ 'form-card-header-nowrap': headerNoWrap }">
      <div class="form-card-header-title">
        <h3 class="form-card-header-title-text">
          {{ formTitle }}
        </h3>
        <h4 v-if="subtitle" class="form-card-header-title-subtitle">
          {{ subtitle }}
        </h4>
      </div>
      <slot name="header-end" />
    </div>
    <div class="card-body"
         :class="{ 'px-i': !noPadding, 'p-0': noPadding, 'form-card-body': !noBorder }">
      <slot />
    </div>
  </div>
</template>

<script>
import { humanize, titleize } from "../../helpers";

export default {
  props: {
    resource: { type: Object },
    resourceName: { type: String },
    sectionTitle: { type: String, default: null },
    subtitle: { type: String, default: null },
    showTitle: { type: Boolean, default: true },
    noPadding: { type: Boolean, default: false },
    noBorder: { type: Boolean, default: false },
    headerNoWrap: { type: Boolean, default: true }
  },

  computed: {
    formTitle () {
      if (this.sectionTitle) {
        return this.sectionTitle;
      } else {
        if (this.$useTranslations) {
          return this.resource.id ? `${this.$t("common.editModel", { model: this.titleizedName() })}`
            : `${this.$t("common.newModel", { model: this.titleizedName() })}`;
        } else {
          return this.resource.id ? `Edit ${this.titleizedName()}` : `New ${this.titleizedName()}`;
        }
      }
    }
  },

  methods: {
    titleizedName () {
      if (this.$useTranslations) {
        return titleize(this.$t(`${humanize(this.resourceName, true)}model`));
      } else {
        return titleize(humanize(this.resourceName));
      }
    }
  }
};
</script>
